import { Point } from "tm-shared/types";
import { isPointDistribution } from "tm-shared/utils";

export const getPointStorageId = (point: Point) => {
    return isPointDistribution(point) ? point.typeContext.storage.id : null;
};

export const getPointStorage = (point: Point) => {
    return isPointDistribution(point) ? point.typeContext.storage : null;
};
